const sliders = document.querySelectorAll('.slider-container');
const $suggestProducts = document.querySelector('.product-recommendations'); 
let slidersArray = [];

for (let i = 0; i < sliders.length; i++) {
    slidersArray.push(new Flickity(sliders[i], {
        // options
        cellAlign: 'center',
        wrapAround: true
    }))
}

if ($suggestProducts) {
    
    setTimeout(() => {
        const $suggestProductSlider = $suggestProducts.querySelector('.product-grid');
        addSuggestProductSlider($suggestProductSlider);

        window.addEventListener('resize', () => {
            addSuggestProductSlider($suggestProductSlider);
        });
    }, 2000);
}

function addSuggestProductSlider(sliderElement) {
    if (typeof suggestProductSlider === 'undefined' && window.innerWidth < 750) {
        const suggestProductSlider = new Flickity(sliderElement, {
            // options
            cellAlign: 'center',
            wrapAround: true
        })
    }
    
    if (window.innerWidth >= 750 && typeof suggestProductSlider !== 'undefined') {
        suggestProductSlider.destroy();
    }
}